import { Avatar, Box, IconButton, Paper, Stack, Typography } from "@mui/material";
import { Email, Phone, WhatsApp } from "@mui/icons-material";

interface OrganiserCardProps {
  name: string;
  email: string | null;
  phone: string | null;
}

const getInitials = (name?: string | null) => {
  if (!name) return "?";
  const parts = name.trim().split(" ").filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0][0].toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

/** Same visual pattern as ViewBooking2's ClientInfoCard -- avatar, name,
 * role label, inline quick-contact actions -- applied to the fundraiser's
 * organiser instead of a booking's client. */
const OrganiserCard: React.FC<OrganiserCardProps> = ({ name, email, phone }) => {
  const handleCall = () => {
    if (phone) window.location.href = `tel:${phone}`;
  };

  const handleWhatsApp = () => {
    if (!phone) return;
    const digits = phone.replace(/[^\d+]/g, "").replace(/^\+/, "");
    window.open(`https://wa.me/${digits}`, "_blank");
  };

  const handleEmail = () => {
    if (email) window.location.href = `mailto:${email}`;
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        mb: 3,
        display: "flex",
        alignItems: "center",
        gap: 2,
        flexWrap: "wrap",
      }}
    >
      <Avatar sx={{ width: 48, height: 48, fontWeight: 700 }}>
        {getInitials(name)}
      </Avatar>
      <Box sx={{ flex: 1, minWidth: 160 }}>
        <Typography fontWeight={700} noWrap>
          {name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Organiser
        </Typography>
      </Box>
      <Stack direction="row" spacing={1}>
        <IconButton
          onClick={handleCall}
          disabled={!phone}
          sx={{ bgcolor: "action.hover" }}
        >
          <Phone fontSize="small" />
        </IconButton>
        <IconButton
          onClick={handleWhatsApp}
          disabled={!phone}
          sx={{ bgcolor: "action.hover" }}
        >
          <WhatsApp fontSize="small" />
        </IconButton>
        <IconButton
          onClick={handleEmail}
          disabled={!email}
          sx={{ bgcolor: "action.hover" }}
        >
          <Email fontSize="small" />
        </IconButton>
      </Stack>
    </Paper>
  );
};

export default OrganiserCard;
